(function () {
  const DEBUG = false;

  /* ========= 語系 ========= */
  const rawLocale =
    Shopify?.locale ||
    document.documentElement.lang ||
    '';

  let LANG = null;
  if (rawLocale.startsWith('en')) LANG = 'en';
  if (rawLocale.startsWith('th')) LANG = 'th';
  if (!LANG) return;

  /* ========= 翻譯表 ========= */
  const TAG_TRANSLATIONS = {
    th: {
      "女款": "หญิง",
      "男款": "ชาย",
      "人身部品": "เสื้อผ้า",
      "款式": "แบบ",
      "車衣": "เสื้อปั่นจักรยาน",
      "車褲": "กางเกงปั่นจักรยาน",
      "外套": "แจ็กเก็ต / เสื้อคลุม",
      "背心": "เสื้อกั๊ก",
      "底衫": "เสื้อชั้นในสำหรับปั่นจักรยาน",
      "手套": "ถุงมือ",
      "帽款": "หมวก",
      "機能T恤": "เสื้อฟังก์ชัน",
      "車襪": "ถุงเท้าและปลอกหุ้มรองเท้า",
      "短袖": "เสื้อปั่นจักรยาน",
      "長袖": "เสื้อปั่นจักรยาน",
      "服飾": "หมวดเสื้อผ้า",
      "配件": "อุปกรณ์เสริม",
      "騎乘配件": "อุปกรณ์เสริม",
      "風鏡": "แว่นตา",
      "水壺": "ขวดน้ำ",
      "補給袋": "ถุงเสบียง",
    },
    en: {
      "外套": "Jackets",
      "女款": "Women",
      "男款": "Men",
      "背心": "Gilets",
      "車衣": "Jersey",
      "車褲": "Bibs",
      "底衫": "Base Layers",
      "短袖": "Jersey",
      "長袖": "Jersey",
      "手套": "Gloves",
      "車襪": "Socks",
      "帽款": "Caps",
      "服飾": "Apparel",
      "配件": "Accessories",
      "騎乘配件": "Accessories",
      "風鏡": "Sunglasses",
      "機能T恤": "Tech T-Shirts",
      "補給袋": "Musette",
      "水壺": "Bidon",
      "款式": "Style",
      "人身部品": "Clothing",
    }
  };

  let observer;

  /* ========= 翻譯單一元素 ========= */
  function translateElement(el) {
    if (el.dataset.i18nDone) return false;

    const text = el.textContent.trim();
    if (!text) return false;

    const translated = TAG_TRANSLATIONS[LANG]?.[text];
    if (translated) {
      el.textContent = translated;
    }

    el.style.visibility = '';
    el.dataset.i18nDone = '1';
    return true;
  }

  /* ========= 主翻譯處理 ========= */
  function process() {
    let touched = 0;

    /* ===== Facet 標題（桌機 + 手機第一層）===== */
    document.querySelectorAll(
      '.usf-title .usf-label,' +
      '.usf-facet-value > .usf-title,' +
      '.usf-mobile-title,' +
      '.usf-drawer-title'
    ).forEach(el => {
      touched += translateElement(el) ? 1 : 0;
    });

    /* ===== Facet 選項（第二層）===== */
    document.querySelectorAll(
      '.usf-facet-value .usf-label span:not(.usf-value),' +
      '.usf-mobile-facet-value span:not(.usf-value)'
    ).forEach(el => {
      touched += translateElement(el) ? 1 : 0;
    });

    /* ===== ⭐ 已選擇項目顯示（usf-dimmed）===== */
    document.querySelectorAll(
      '.usf-dimmed span'
    ).forEach(el => {
      touched += translateElement(el) ? 1 : 0;
    });

    /* ⭐ 新增：翻譯 Refine by 的值 */
    document.querySelectorAll(
      '.usf-refineby__item b'
    ).forEach(el => {
      touched += translateElement(el) ? 1 : 0;
    });

    if (DEBUG && touched) {
      console.log('[USF i18n] translated:', touched);
    }
  }

  /* ========= 監聽 ========= */
  function startObserver() {
    observer = new MutationObserver(() => {
      process();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /* ========= 手機 Filter 打開時強制翻 ========= */
  function bindMobileEvents() {
    document.body.addEventListener('click', e => {
      const btn = e.target.closest(
        '.usf-mobile-filter-button, .usf-filter-button'
      );
      if (btn) {
        setTimeout(process, 50);
        setTimeout(process, 300);
        setTimeout(process, 800);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    startObserver();
    bindMobileEvents();

    process();
    setTimeout(process, 300);
    setTimeout(process, 800);
  });

})();